<template>
    <div>
        <p class="lh35 hid" id="konav">&nbsp;</p>
        <div id="content" class="w">
            <!--left nav-->
            <div class="bl_l left">
                <div v-for="(item,index) in cate" :key="index">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:item.id}}" target="_blank" class="l_aa">
                        <img :src="item.piclink" width="45" height="45">
                        <p>{{item.title}}</p>
                    </router-link>
                </div>
                <div class="clear"></div>
                <p class="lh16">&nbsp;</p>
            </div>
            <!-- right content -->
            <div class="bl_m left">
                <!-- right carousel -->
                <div id="bl_m">
                    <catesearch-carousel :height="height" :width="890" :carouselList="banner"></catesearch-carousel>
                </div>
                <!-- right bottom -->
                <router-link :to="{path:'/detail', query:{id:15}}" target="_blank" class="ll_r">
                    <img src="../../assets/image/productBanner/woman/product/1.jpg" width="290" height="150">
                </router-link>
                <router-link :to="{path:'/detail', query:{id:25}}" target="_blank" class="ll_r">
                    <img src="../../assets/image/productBanner/woman/product/2.jpg" width="290" height="150">
                </router-link>
                <!-- <a href="javascript:;" class="ll_r"> -->
                <router-link :to="{path:'/detail', query:{id:100}}" target="_blank" class="ll_r">
                    <img src="../../assets/image/productBanner/woman/product/3.jpg" width="290" height="150">
                </router-link>
                <!-- </a> -->
            </div>
            <!--mid over-->
            <div class="clear"></div>
            <div class="over mt35 wbox" id="wbox">
                <div class="c_tt yahei">
                    <h1 class="dinl">女性用品</h1>热卖榜 <em class="c9">MASTERPIECE</em>
                </div>
                <div v-for="(itemss,index) in product" :key="index">
                    <router-link :to="{path:'/detail', query:{id:itemss.id}}" target="_blank" class="dn_a">
                        <img :src="itemss.piclink" width="270" height="270" class="sbm">
                        <div class="h250">
                            <p class="gna pt10">{{itemss.title}}</p>
                            <p class="pt_g">{{itemss.sub_title}}</p>
                            <p class="gp_d mt5">
                                <i class="rmb left">¥</i>
                                <b class="xj left mr5">{{itemss.price}}</b>
                                <em class="cs_o">已售{{itemss.invent_sale}}件</em>
                            </p>
                        </div>
                        <span class="hot_tag"></span>
                    </router-link>
                </div>
                
            </div>
            <!--one over-->
            <p class="lh30">&nbsp;</p>
            <!-- 热销 -->
            <div class="ov w_hd">
                <router-link :to="{path:'/ranking'}" target="_blank">
                    <img src="../../assets/picture/category/paihangbang.jpg" width="1190" height="90">
                </router-link>
            </div>
        </div>
        <!--content over-->
        <div class="w" id="gdls">
            <div v-for="(item,index) in category" :key="index">
                <div class="blt mt35">
                    <div class="c_tt yahei">
                        <router-link :to="{path:'/shop/shopsearch', query:{cate_id:item.id}}" target="_blank">
                            <h2 class="dinl c3">{{item.title}}</h2>
                        </router-link>
                    </div>
                </div>

                <div class="bdls">
                    <dl class="gl" v-for="(items,indexs) in item.p" :key="indexs" @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                        <dt>
                            <router-link :to="{path:'/detail', query:{id:items.id}}" target="_blank">
                                <img :src="items.piclink" width="270" height="270" class="sbm">
                            </router-link>
                        </dt>
                        <!-- <dd class="simg">
                            <img src="https://s.cccgx.com/t/26x26/images/qu/10201/gallery/20211025025923_30410.jpg" width="26" height="26" class="ss_m">
                        </dd> -->
                        <dd class="simg">
                            <router-link :to="{path:'/detail', query:{id:items.id}}" target="_blank" class="gna">
                                {{items.title}}
                            </router-link>
                        </dd>
                        <dd class="gp_d">
                            {{items.sub_title}}
                        </dd>
                        <dd class="gp_d">
                            <i class="rmb left">¥</i>
                            <b class="xj left">{{items.price}}</b>
                            <em class="cs_o">已售{{items.invent_sale}}件</em>
                        </dd>
                        <dd class="pt5">
                            <em class="i_hot">热销</em>
                            <i class="i_by">包邮</i>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <!--gdl content over-->
        <div class="w over">
            <div class="bgw mt35 pd20" style="overflow: hidden;">
                <b class="pr10" style="float:left;">所有女性用品分类：</b>
                <div v-for="items in cate" :key="items.id">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:items.id}}" target="_blank" class="pl10" style="float:left;">
                        <p>{{items.title}}</p>
                    </router-link>
                </div>
            </div>
        </div>
        <!--content over-->
    </div>
</template>

<script>
import Catesearch_carousel from "@/components/common/catesearch-carousel"

export default{
    components:{
        'catesearch-carousel': Catesearch_carousel
    },
    data(){
        return{
            height:'320',
            //数据
            cate:[],
            category:[],
            product:[],
            type: 1,
            banner:[
                {id:25,url:require('@/assets/image/productBanner/woman/banner/chuandaihudie.jpg'),title:'跳蛋女用学生无线遥控外出穿戴隐形内裤上班强劲震静音高潮性玩具'},
                {id:253,url:require('@/assets/image/productBanner/woman/banner/jinglingniao.jpg'),title:'跳蛋吮吸入体女性自慰器秒潮性女用品情趣成人用品性玩具强震调情'},
                {id:254,url:require('@/assets/image/productBanner/woman/banner/ledou.jpg'),title:'震动棒炮机成人情趣女用品自慰器性用具玩具女性自神器慰插入高潮'},
                {id:249,url:require('@/assets/image/productBanner/woman/banner/xiaoruanmeng.jpg'),title:'震动棒成人情趣女用品自慰器性用具玩具女性自神器慰插入工具高潮'},
                {id:224,url:require('@/assets/image/productBanner/woman/banner/yangju.jpg'),title:'全自动伸缩阳具仿真假阴茎罗马大帝女性自慰卫器自尉棒加温炮击机'}
            ]
        }
    },
    mounted() {
        this.getNyqjCate();
        this.getNyqjHot();
        this.getNyqjSonHot();
    },
    methods:{
        //获取所有子分类
        getNyqjCate() {
            this.$api.getCategory.getNyqjCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.soncate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取所有热销产品
        getNyqjHot() {
            this.$api.getCategory.getNyqjHot({}).then(res => {
                if (res.code == 200) {
                    this.product = [];
                    var arr = res.result.product;
                    arr.forEach(item => {
                        this.product.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取所有子分类热销产品
        getNyqjSonHot() {
            this.$api.getCategory.getNyqjSonHot({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach(item => {
                        this.category.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/woman/Index.vue